import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class BackService {
  private static readonly STORAGE_KEY = "fairapp_backPath";
  private static readonly DEFAULT_PATH = "/dashboard";

  get backPath(): string {
    return sessionStorage.getItem(BackService.STORAGE_KEY) ?? BackService.DEFAULT_PATH;
  }

  set backPath(value: string) {
    sessionStorage.setItem(BackService.STORAGE_KEY, value);
  }
}
